import { AuthenticatedLayout } from "../../../../../layouts";
import { ConnectZoho } from "../../../../../components/AddOns/Accounting/ZohoBooks/ConnectZoho";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const ConnectZohoPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Connect Zoho"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Connect Zoho", navigateTo: "#" }
      ]}
      mainContents={<ConnectZoho />}
    />
  );
};
